import { render, staticRenderFns } from "./DImageUploadPreview.vue?vue&type=template&id=36865476&"
import script from "./DImageUploadPreview.vue?vue&type=script&lang=js&"
export * from "./DImageUploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./DImageUploadPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports